export default __webpack_public_path__ + "static/Living-in-STL_3-e8bac8acd8fa6f4472edd370fa195fb2.jpg";